import type { FC } from "react";

import notFound from "@/assets/images/NotFoundMan.svg";
import { cn } from "@/lib/utils";

interface NotFoundProps {
  value: string;
  title?: string;
  className?: string;
}

const NotFound: FC<NotFoundProps> = ({
  value,
  title = "No results found",
  className,
}) => {
  return (
    <div
      className={cn(
        "flex justify-center items-center w-full h-[60vh]",
        className
      )}
    >
      <div className="flex flex-col gap-2 max-w-[330px] items-center">
        <img src={notFound} alt="No results found" className="w-[230px]" />
        <p className="font-bold">{title}</p>
        <div>
          <p className="text-center text-sm">
            We couldn’t find any results
            {value && (
              <span className="pl-1">
                for “<span className="font-bold">{value}</span>”
              </span>
            )}
            .
          </p>
          <p className="text-center text-sm">
            Try searching for something else.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
